import { NgRedux, select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { ApplicationUser } from '../models/application.user.interface';
import { IAppState } from '../../store/IAppState';
import { ChannelEventFactory, ChannelEvent, TRANSMIT_ACTION } from '../services/channel.event.factory';
import { ChannelService } from '../services/channel.service';
import { NGXLogger } from 'ngx-logger';
import { SharedActions } from '../../shared/shared.actions';

export class SignalrListener {
    @select('applicationUser') public applicationUser$: Observable<ApplicationUser>;

    private signalrUserChannel: string;
    static  signalRGeneralSubscription ; 

    private broadcastChannel = new BroadcastChannel('userChannel');

    constructor(
        protected readonly ngRedux: NgRedux<IAppState>,
        protected readonly sharedActions: SharedActions,
        protected readonly channelEventFactory: ChannelEventFactory,
        protected readonly channelService: ChannelService,
        protected readonly logger: NGXLogger,
    ) {
        this.channelService.starting$.subscribe(
            () => {
                this.applicationUser$.subscribe((data: ApplicationUser) => {
                    if (data) {
                        this.signalrUserChannel = data.id;

                        this.signalRSubscribeToGeneralChannel();

                        this.channelService.sub(data.id).subscribe(
                            (e: ChannelEvent) => {
                                if (e.name === TRANSMIT_ACTION) {
                                    var data = e.data;
                                    if(this.messageReceiverIsDifferentFromSender(data.uniqueTabId))
                                    {
                                        const action = data.data;
                                        // tslint:disable-next-line:max-line-length
                                        this.logger.debug(`SignalR received event: ${TRANSMIT_ACTION}::${action.type}`, this.signalrUserChannel, 'starting', 'SIGNALR', '');
                                        this.ngRedux.dispatch(action);
                                    }
                                }
                            },
                            () => {
                                // tslint:disable-next-line:max-line-length
                                this.logger.error('SignalR: Attempt to join general channel failed', this.signalrUserChannel, 'starting', 'SIGNALR', '');
                            },
                        );
                    }
                });
            },
            () => {
                // tslint:disable-next-line:max-line-length
                this.logger.error('SignalR: Service failed to start', this.signalrUserChannel, 'starting', 'SIGNALR', '');
            },
        );
        this.broadcastChannel.onmessage = (ev: MessageEvent) => {
            let message = ev.data.data;
            if(this.messageReceiverIsDifferentFromSender(message.uniqueTabId))
            {
                // tslint:disable-next-line:max-line-length
                this.logger.debug(`Broadcaster received event: ${message.data.type}`);
                this.ngRedux.dispatch(message.data);
            }
        };
    }

    public initialize(): Promise<any> {
        return this.channelService.start();
    }

    private signalRSubscribeToGeneralChannel(): void {
        if (!SignalrListener.signalRGeneralSubscription) {
            console.log("subscribing");
        SignalrListener.signalRGeneralSubscription = this.channelService.sub('general');
            SignalrListener.signalRGeneralSubscription.subscribe(
            (e: ChannelEvent) => {
                if (e.name === TRANSMIT_ACTION) {
                    const action = JSON.parse(e.json).data;
                    if(action) {
                    // tslint:disable-next-line:max-line-length
                    this.logger.debug(`SignalR received event (channel: general): ${TRANSMIT_ACTION}::${action.type}`, this.signalrUserChannel, 'starting', 'SIGNALR', '');
                    this.sharedActions.addChannelEventToInventory(e);
                    this.ngRedux.dispatch(action);
                    }
                    else
                    {
                        console.log(`No Action Data received from SignalR (channel: general) , ${e.json}`) ;
                    }
                }
            },
            () => {
                // tslint:disable-next-line:max-line-length
                this.logger.error('SignalR: Attempt to join general channel failed', this.signalrUserChannel, 'starting', 'SIGNALR', '');
            },
        );
        }
    }

    private getUniqueTabId(): number {
        return sessionStorage.tabID ? sessionStorage.tabID : sessionStorage.tabID = Math.random();
    }

    private messageReceiverIsDifferentFromSender(uniqueTabId: number): boolean {
        return uniqueTabId !== this.getUniqueTabId();
    }
}
